import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationBarComponent } from './notification-bar.component';
import { NotificationBarService } from '../../shared/services/notification/notification-bar.service';
import { SvgIconModule } from '../../shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forRoot()
  ],
  providers: [
    NotificationBarService
  ],
  declarations: [
    NotificationBarComponent
  ],
  exports: [
    NotificationBarComponent
  ]
})

export class NotificationBarModule {}
